"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon = _interopRequireDefault(require("./../../../fonts/icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class TableColumnHeader extends _react.default.Component {
  constructor(props) {
    super(props);
    this.sortColumn = null;
    this.sortOrder = null;
    this.sortIndex = null;
  }
  render() {
    const {
      column,
      onSort,
      sortBy
    } = this.props;
    for (let i = 0; i < sortBy.length; i++) {
      if (sortBy[i].column === column.key) {
        this.sortColumn = sortBy[i].column;
        this.sortOrder = sortBy[i].order;
        this.sortIndex = i;
      }
    }
    return !column.sortable ? /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: 'table-header align-top'
    }, column.displayName) : /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: 'table-header align-top',
      onClick: () => onSort(),
      style: {
        cursor: 'pointer'
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, column.displayName), this.sortColumn ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icons ml-1"
    }, sortBy.length ? this.sortOrder === 'DESC' ? /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "expand_more",
      size: 16
    }) : /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "expand_less",
      size: 16
    }) : /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "unfold_more",
      size: 16
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "badge badge-pill badge-primary ml-1"
    }, this.sortIndex + 1)) : /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icons ml-1"
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "unfold_more",
      size: 16
    })));
  }
}
var _default = exports.default = TableColumnHeader;
module.exports = exports.default;